(function () {
    'use strict';

    angular
        .module('app.checklists')
        .controller('ChecklistsController', ChecklistsController);

    ChecklistsController.$inject = ['common', 'dataservice', 'config'];
    /* @ngInject */
    function ChecklistsController(common, dataservice, config) {
        var vm = this;
        vm.upcoming = 1;
        vm.title = "Information"

        activate();

        function activate() {
            var promises = [getItems()];
            return common.$q.all(promises).then(function () {
                common.logger.info('Activated ' + vm.title + ' View');
                common.notifier.notify(config.events.refreshCounts);
            }, function (error) { });
        }

        function getItems() {
            return dataservice.getItem("api/Checklists/0").then(function (response) {
                vm.item = response.data;
                
                return vm.item;
            }, function (error) { });
        }
    }
})();
